const AUTH_ERROR_MAP: Record<number, string> = {
  2254: "This email cannot be used to register.",
  2259: "This account is not active.",
  2261: "Email login is currently unavailable.",
  2262: "Google login is currently unavailable.",
}

export function authErrorMessage(error: unknown): string {
  const err = error as { data?: { code?: number }; message?: string }
  const code = err?.data?.code
  if (typeof code === "number" && AUTH_ERROR_MAP[code]) {
    return AUTH_ERROR_MAP[code]
  }
  return err?.message || "Authentication failed."
}
